import { render, staticRenderFns } from "./SeriDataGrafik.vue?vue&type=template&id=1d2e6233&scoped=true&"
import script from "./SeriDataGrafik.vue?vue&type=script&lang=js&"
export * from "./SeriDataGrafik.vue?vue&type=script&lang=js&"
import style0 from "./SeriDataGrafik.vue?vue&type=style&index=0&id=1d2e6233&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2e6233",
  null
  
)

export default component.exports